import React, { useContext, useState, useEffect } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import useGroupUngroup from "../../../hooks/useGroupUngroup";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import { isUnsuportedWidgetsInSelection } from "../../../_helpers/utils";

let style = Object.assign({}, global);

const Group = props => {
  const { group: initWidgetGroup } = useGroupUngroup();
  const { metadata } = useContext(EditorContext);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isMac, setIsMac] = useState();

  useEffect(() => {
    setIsDisabled(isUnsuportedWidgetsInSelection(metadata.activeWidgetId));
  });

  useEffect(() => {
    let isMacOS = /Mac/i.test(navigator.platform) || /Macintosh/i.test(navigator.userAgent);
    setIsMac(isMacOS);
  }, []);

  return (
    <li
      className={cx(style["toolset-group"], {
        [style["disabled"]]: isDisabled,
      })}>
      <div className={cx(style["toolset-item"], style["group-wrap"])}>
        <span
          className={cx(style["toolset-action"], style["custom-tooltip"])}
          onClick={() => !isDisabled && initWidgetGroup()}>
          <Icon icon="ui-group" />
          {props.rightContext && (
            <>
              Group {props.rightContext && !isMac && <span>Ctrl+G</span>}
              {props.rightContext && isMac && <span>Cmd+G</span>}
            </>
          )}
          {!props.rightContext && <div className={cx(style["custom-tooltip-content"], style["top"])}>Group</div>}
        </span>
      </div>
    </li>
  );
};
Group.propTypes = {
  rightContext: PropTypes.bool,
};

export default Group;
